export default __webpack_public_path__ + "static/media/dracula-beyond-stoker-issue-1.95d52611.jpg";